import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "overflow-y-auto no-scrollbar h-full w-full" }
const _hoisted_2 = { class: "pt-2 xl:pt-[100px] px-1 xl:px-8 pb-8 flex flex-col gap-4 text-left" }
const _hoisted_3 = { class: "flex justify-between max-md:flex-col" }
const _hoisted_4 = { class: "text-2xl sm:text-3xl font-bold text-brown" }
const _hoisted_5 = { class: "flex items-center bg-white p-1 rounded-xl border border-divider shadow-sm self-start sm:self-auto w-full sm:w-auto overflow-x-auto" }

import { useI18n } from "vue-i18n";
import { computed, ref } from "vue";
import SettingsComponent from "@/views/Calculators/PersonalDates/components/SettingsComponent.vue";
import {
  FavorableDateSelectionRequest,
  FavorableMonthReport,
  MonthDayReport,
} from "@/types/calculators";
import { fetchMonthDates } from "@/api/favorableDates";
import BestDaysByCategoryComponent from "@/views/Calculators/PersonalDates/components/monthReport/BestDaysByCategoryComponent.vue";
import TopDaysComponent from "@/views/Calculators/PersonalDates/components/monthReport/TopDaysComponent.vue";
import MonthTableComponent from "@/views/Calculators/PersonalDates/components/monthReport/MonthTableComponent.vue";
import DayReportPreviewComponent from "@/views/Calculators/PersonalDates/components/monthReport/DayReportPreviewComponent.vue";
import DayDetailReportComponent from "@/views/Calculators/PersonalDates/components/dayReport/DayDetailReportComponent.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'PersonalDateSelectionView',
  setup(__props) {

const { t } = useI18n();
const showSettings = ref(true);
const showDetailsView = ref(false);
const monthReport = ref<FavorableMonthReport | null>(null);
const selectedCard = ref<MonthDayReport | null>(null);
const lastRequest = ref<FavorableDateSelectionRequest | null>(null);
const isCalendarView = ref<boolean>(true);

const selectedDateString = computed(() => {
  if (!selectedCard.value) {
    return "";
  }
  const [, month, day] = selectedCard.value.date.split("-");

  return `(${day}.${month})`;
});

async function getMonthData(request: FavorableDateSelectionRequest) {
  lastRequest.value = request;
  monthReport.value = await fetchMonthDates(request);
}

async function handleSelectedCard(
  dayReport: MonthDayReport,
  isForceOpen = false
) {
  if (
    isForceOpen ||
    (selectedCard.value && selectedCard.value.date === dayReport.date)
  ) {
    showDetailsView.value = true;
  }
  selectedCard.value = dayReport;
}

function handleBackToCalendar() {
  showDetailsView.value = false;
}

function handleNextDay() {
  const context = getContextInfo();
  if (!context) return;

  const { days, dayIndex } = context;

  if (dayIndex === days.length - 1) return;

  selectedCard.value = days[dayIndex + 1];
}

function handlePrevDay() {
  const context = getContextInfo();
  if (!context) return;

  const { days, dayIndex } = context;

  if (dayIndex === 0) return;

  selectedCard.value = days[dayIndex - 1];
}

function handleSelectDay(selectedDay: MonthDayReport) {
  selectedCard.value = selectedDay;
  showDetailsView.value = true;
}

function handleToggleDetailView() {
  if (selectedCard.value) {
    showDetailsView.value = true;
  }
}

function getContextInfo() {
  const days = monthReport.value?.days;
  const currentCard = selectedCard.value;

  if (!days || !currentCard) return null;

  const dayIndex = days.findIndex((day) => day.date === currentCard.date);
  if (dayIndex === -1) return null;

  return { days, dayIndex };
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)("calculators.personal-date.title")), 1),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            class: _normalizeClass(["font-semibold px-3 py-2 rounded-lg text-xs transition-all flex items-center justify-center gap-1.5 shrink-0", 
              showSettings.value
                ? 'bg-beige text-active'
                : 'text-alternative-gray hover:text-brown'
            ]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showSettings.value = !showSettings.value))
          }, [
            _createElementVNode("span", null, _toDisplayString(_unref(t)("calculators.personal-date.settings")), 1),
            _createElementVNode("span", {
              class: _normalizeClass(["text-[10px]", { 'rotate-180': !showSettings.value }])
            }, " ▲ ", 2)
          ], 2),
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "w-px h-4 bg-divider mx-1 shrink-0" }, null, -1)),
          _createElementVNode("button", {
            class: _normalizeClass(["flex-1 sm:flex-initial px-3.5 py-2 rounded-lg text-xs transition-all flex items-center justify-center gap-1.5 shrink-0", 
              showDetailsView.value
                ? 'text-alternative-gray hover:text-brown'
                : 'bg-brown text-white shadow-sm'
            ]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (showDetailsView.value = false))
          }, [
            _createElementVNode("span", null, _toDisplayString(_unref(t)("calculators.personal-date.calendar-view")), 1)
          ], 2),
          _createElementVNode("button", {
            class: _normalizeClass(["font-semibold flex-1 sm:flex-initial px-3.5 py-2 rounded-lg text-xs transition-all flex items-center justify-center gap-1.5 shrink-0", 
              showDetailsView.value
                ? 'bg-brown text-white shadow-sm'
                : 'text-alternative-gray hover:text-brown'
            ]),
            onClick: handleToggleDetailView
          }, [
            _createElementVNode("span", null, _toDisplayString(_unref(t)("calculators.personal-date.day-report", {
                  day: selectedDateString.value,
                })), 1)
          ], 2)
        ])
      ]),
      _createVNode(SettingsComponent, {
        showFullCard: showSettings.value,
        onSubmitForm: getMonthData
      }, null, 8, ["showFullCard"]),
      (monthReport.value !== null && !showDetailsView.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(BestDaysByCategoryComponent, {
              startDay: monthReport.value.meta.start_date,
              endDay: monthReport.value.meta.end_date,
              bestDaysCount: monthReport.value.range_summary.counts,
              dayStem: monthReport.value.user_natal_summary.day_master.stem,
              yearPillar: 
            monthReport.value.range_summary.top_recommended_days[0].pillars.year
          ,
              isCalendarView: isCalendarView.value,
              onShowAsCalendar: _cache[2] || (_cache[2] = (asCalendar) => (isCalendarView.value = asCalendar))
            }, null, 8, ["startDay", "endDay", "bestDaysCount", "dayStem", "yearPillar", "isCalendarView"]),
            _createVNode(TopDaysComponent, {
              topDays: monthReport.value.range_summary.top_recommended_days,
              onSelectDay: handleSelectDay
            }, null, 8, ["topDays"]),
            _createVNode(MonthTableComponent, {
              bestDaysByCategory: monthReport.value.range_summary.best_days_by_category,
              days: monthReport.value.days,
              selectedCard: selectedCard.value,
              isCalendarView: isCalendarView.value,
              onSelectCard: handleSelectedCard
            }, null, 8, ["bestDaysByCategory", "days", "selectedCard", "isCalendarView"]),
            (selectedCard.value)
              ? (_openBlock(), _createBlock(DayReportPreviewComponent, {
                  key: 0,
                  selectedCard: selectedCard.value,
                  onOpenFullReport: _cache[3] || (_cache[3] = ($event: any) => (showDetailsView.value = true))
                }, null, 8, ["selectedCard"]))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true),
      (selectedCard.value !== null && showDetailsView.value)
        ? (_openBlock(), _createBlock(DayDetailReportComponent, {
            key: 1,
            lastRequest: lastRequest.value,
            selectedCard: selectedCard.value,
            onBackToCalendar: handleBackToCalendar,
            onNextDay: handleNextDay,
            onPrevDay: handlePrevDay
          }, null, 8, ["lastRequest", "selectedCard"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})